/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import useFetch from '@common/hooks/useFetch';
import ComTable from '@components/common/ComTable';
import { saveAs } from 'file-saver';
import {
  convertTimeToHHMMSS,
  dateTimeFormat,
  getDateRangeSuffix,
} from '@common/utils/dateHelper';
import {
  ACTION_OPTION_PREFIX,
  COMPANY_OPTION_PREFIX,
  LAYOUT_OPTION_PREFIX,
  USERNAME_OPTION_PREFIX,
} from '@common/constant/option';
import {
  ANALYTIC_INDEPTH_MODE,
  ANALYTIC_LIST_MODE,
  FILTER_PICKER_MODE,
  FILTER_PICKER_RANGE_MODE,
} from '@common/constant/mode';
import {
  TABLE_PAGE_NUMBER,
  TABLE_PAGE_SIZE,
  TABLE_SORT_ASC,
  TABLE_SORT_DESC,
} from '@common/constant/table';
import ComSwitch from '@components/common/ComSwitch';
import ComMonthSelector from '@components/common/ComMonthSelector';
import ComMonthPicker from '@components/common/ComMonthPicker';
import { processFilterOptions } from '@common/utils/optionFilterHelper';
import { IconExportExcel } from '@assets/icons';
import { ReloadOutlined } from '@ant-design/icons';
import {
  getFilterConfigForComponent,
  isDepthMode,
  isMonthPickerMode,
} from '@common/utils/modeHelper';
import { Flex } from 'antd';
import { t } from 'i18next';
import { fabAccessLogApi } from '@services/fabAccessLogApi';
import { AnalyticContext } from '..';

function AnalyticList() {
  const [pagination, setPagination] = useState({
    page_number: TABLE_PAGE_NUMBER,
    page_size: TABLE_PAGE_SIZE,
    order: TABLE_SORT_DESC,
    keyword: '',
    user_ids: null,
    events_types: null,
    fab_ids: null,
    company_ids: null,
    from_date: null,
    to_date: null,
    order_by: 'createdAt',
  });

  const [optionFilter, setOptionFilter] = useState([]);
  const [modeFilter, setModeFilter] = useState(FILTER_PICKER_MODE); // picker | picker_range
  const { mode, setMode, monthOptions, filterOptions } =
    useContext(AnalyticContext);

  const { loadingTable, value, reload } = useFetch(() => {
    if (!pagination.from_date || !pagination.to_date) {
      return null;
    }
    return fabAccessLogApi.getListAccessLogs(pagination);
  }, [
    pagination.page_number,
    pagination.page_size,
    pagination.order,
    pagination.order_by,
    pagination.keyword,
    pagination.user_ids,
    pagination.events_types,
    pagination.fab_ids,
    pagination.company_ids,
    pagination.layout_ids,
    pagination.from_date,
    pagination.to_date,
  ]);

  useEffect(() => {
    const filterConfig = getFilterConfigForComponent(ANALYTIC_LIST_MODE);
    if (filterOptions && Object.keys(filterOptions).length > 0) {
      const allOptions = processFilterOptions(filterOptions);
      setOptionFilter(
        filterConfig.map((item) => ({
          ...item,
          children: allOptions[item.dataKey] || [],
        })),
      );
    } else {
      setOptionFilter(
        filterConfig.map((item) => ({
          ...item,
          children: [],
        })),
      );
    }
  }, [filterOptions]);

  const paginationProp = {
    position: ['bottomRight'],
    total: value?.data?.count,
    pageSize: pagination?.page_size,
    currentPage: pagination?.page_number,
  };

  const handleSearch = (values) => {
    setPagination({
      ...pagination,
      keyword: values,
      page_number: TABLE_PAGE_NUMBER,
    });
  };

  const handleChangePagination = (currentPage, pageSize) => {
    setPagination((curState) => ({
      ...curState,
      page_size: pageSize,
      page_number: currentPage,
    }));
  };

  const hanldeChangeTable = (_, filter, sorter) => {
    if (sorter?.order === 'descend') {
      setPagination({
        ...pagination,
        order: TABLE_SORT_DESC,
        order_by: sorter?.field,
      });
    } else {
      setPagination({
        ...pagination,
        order: TABLE_SORT_ASC,
        order_by: sorter?.field,
      });
    }
  };

  const onChangeTreeSelect = (dataSelect) => {
    const groups = {
      [COMPANY_OPTION_PREFIX]: [],
      // [FAB_OPTION_PREFIX]: [],
      [LAYOUT_OPTION_PREFIX]: [],
      [USERNAME_OPTION_PREFIX]: [],
      [ACTION_OPTION_PREFIX]: [],
    };
    dataSelect.forEach((item) => {
      const [prefix, vId] = item.split('_');
      if (groups[prefix]) groups[prefix].push(Number(vId));
    });
    setPagination({
      ...pagination,
      user_ids:
        groups[USERNAME_OPTION_PREFIX].length > 0
          ? groups[USERNAME_OPTION_PREFIX].join(',')
          : null,
      events_types:
        groups[ACTION_OPTION_PREFIX].length > 0
          ? groups[ACTION_OPTION_PREFIX].join(',')
          : null,
      company_ids:
        groups[COMPANY_OPTION_PREFIX].length > 0
          ? groups[COMPANY_OPTION_PREFIX].join(',')
          : null,
      // fab_ids:
      //   groups[FAB_OPTION_PREFIX].length > 0
      //     ? groups[FAB_OPTION_PREFIX].join(',')
      //     : null,
      layout_ids:
        groups[LAYOUT_OPTION_PREFIX].length > 0
          ? groups[LAYOUT_OPTION_PREFIX].join(',')
          : null,
      page_number: TABLE_PAGE_NUMBER,
    });
  };

  const filterTreeNode = (inputValue, treeNode) => {
    const title = treeNode?.props?.title.trim() || '';
    return title.toLowerCase().includes(inputValue.toLowerCase().trim());
  };

  const exportExcelFile = useCallback(
    async (dataExport) => {
      try {
        const fileData = await fabAccessLogApi.exportListAccessLogs(dataExport);
        const blob = new Blob([fileData], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const exportSuffix = getDateRangeSuffix(
          pagination.from_date,
          pagination.to_date,
          modeFilter,
          'YYYYMM',
        );
        saveAs(blob, `FaView_ログ一覧_${exportSuffix}.xlsx`);
      } catch (error) {
        console.error('Error exporting to Excel:', error);
      }
    },
    [pagination.from_date, pagination.to_date, modeFilter],
  );

  const handleModeChange = (switchValue) => {
    setMode(switchValue ? ANALYTIC_INDEPTH_MODE : ANALYTIC_LIST_MODE);
  };

  const handleFilterChange = (switchValue) => {
    setModeFilter(switchValue ? FILTER_PICKER_RANGE_MODE : FILTER_PICKER_MODE);
  };

  const handleMonthSelectorChange = useCallback((year, month) => {
    const parsedMonth = dayjs()
      .set('month', month - 1)
      .set('year', year);
    setPagination((prev) => ({
      ...prev,
      page_number: TABLE_PAGE_NUMBER,
      from_date: parsedMonth.startOf('month').format('YYYY-MM-DD'),
      to_date:
        year === dayjs().year() && month === dayjs().month() + 1
          ? dayjs().format('YYYY-MM-DD')
          : parsedMonth.endOf('month').format('YYYY-MM-DD'),
    }));
  }, []);

  const handleMonthPickerChange = useCallback((fromDate, toDate) => {
    setPagination((prev) => ({
      ...prev,
      page_number: TABLE_PAGE_NUMBER,
      from_date: dayjs(fromDate).startOf('month').format('YYYY-MM-DD'),
      to_date: dayjs(toDate).isSame(dayjs(), 'month')
        ? dayjs().format('YYYY-MM-DD')
        : dayjs(toDate).endOf('month').format('YYYY-MM-DD'),
    }));
  }, []);

  const columns = [
    {
      title: t('analytic.list.table.createdTime'),
      dataIndex: 'createdAt',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      key: 'createdAt',
      width: 100,
      render: (values) => (
        <div className="display-flex jc-center">{dateTimeFormat(values)}</div>
      ),
    },
    {
      title: t('analytic.list.table.username'),
      dataIndex: 'username',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      key: 'username',
      width: 150,
      render: (_, values) => values.username,
    },
    {
      title: t('analytic.list.table.action'),
      dataIndex: 'events_type',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      key: 'events_type',
      width: 25,
      render: (values) => {
        return (
          <div className="display-flex jc-center">
            {values === 0 ? '入室' : '退室'}
          </div>
        );
      },
    },
    {
      title: t('analytic.list.table.destination'),
      dataIndex: 'company_name',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      key: 'company_name',
      width: 150,
      render: (_, values) => {
        return (
          <div className="display-flex">
            {values.company_name ? (
              <>
                {values.company_name} {'>'} {values.layout_name}
              </>
            ) : (
              <>{values.layout_name}</>
            )}
          </div>
        );
      },
    },
    {
      title: t('analytic.list.table.duration'),
      dataIndex: 'play_time',
      key: 'play_time',
      width: 50,
      render: (values) => {
        return (
          <div className="display-flex jc-center">
            {convertTimeToHHMMSS(values)}
          </div>
        );
      },
    },
  ];

  return (
    <div className="analytic-list-wrapper full-width">
      <ComTable
        loading={loadingTable}
        columns={columns}
        data={value?.data?.data}
        pagination={paginationProp}
        onSearch={handleSearch}
        onChangeTable={hanldeChangeTable}
        onChangePagination={handleChangePagination}
        onChangeTreeSelect={onChangeTreeSelect}
        optionsTreeSelect={optionFilter}
        treeNodeFilterProp="title"
        filterTreeNode={filterTreeNode}
        isTreeSelect
        dataExport={pagination}
        buttonExport
        hideTitleBar
        showCustomBar
        customBar={
          <Flex justify="space-between" align="center" className="title-header">
            <Flex align="center" gap="small">
              <span>{t('analytic.list.header.title')}</span>
              <ComSwitch
                defaultChecked={isDepthMode(mode)}
                onSwitchChange={handleModeChange}
              />
              <span>{t('analytic.list.header.log_list')}</span>
            </Flex>

            <Flex align="center" gap="small">
              <Flex align="center" gap="small">
                <span>{t('analytic.list.header.specify_period')}</span>
                <ComSwitch onSwitchChange={handleFilterChange} />
                {isMonthPickerMode(modeFilter) ? (
                  <ComMonthSelector
                    options={monthOptions}
                    onMonthChange={handleMonthSelectorChange}
                  />
                ) : (
                  <ComMonthPicker
                    options={monthOptions}
                    onMonthChange={handleMonthPickerChange}
                  />
                )}
              </Flex>

              <Flex align="center" gap="small">
                <IconExportExcel
                  className="pointer"
                  onClick={() => exportExcelFile(pagination)}
                />
                <ReloadOutlined className="pointer" onClick={() => reload()} />
              </Flex>
            </Flex>
          </Flex>
        }
      />
    </div>
  );
}

export default AnalyticList;
